import React from "react"

import * as speakersStyles from "../../styles/landing_pages/Speakers.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

export default function Speakers(props) {
  const { content } = props

  const titleSection = ChildSelector.select(
    content,
    `speakers-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const speakers = ChildSelector.select(
    content,
    `speaker-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(speaker => ({
    holder: speaker,
    name: ChildSelector.select(
      speaker,
      `name`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    jobDescription: ChildSelector.select(
      speaker,
      `job-description`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    company: ChildSelector.select(
      speaker,
      `company`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    description: ChildSelector.select(
      speaker,
      `description`,
      ChildSelector.SELECTOR_TYPE.ARRAY,
    ).map(d => d.innerHTML),
  }))

  return (
    <>
      <div
        className={`row ${props.className} ${speakersStyles.wrapper}`}
      >
        <div className={`col-12 ${speakersStyles.title}`}>
          <h1>{titleSection}</h1>
        </div>
        <div
          className={`row ${props.className} ${speakersStyles.contentWrapper}`}
        >
          {speakers &&
            speakers.map((speaker, idx) => (
              <div className={`col-12 col-lg-4 ${speakersStyles.content}`} key={idx}>
                <div className={`${speakersStyles.card}`}>
                  <div className={`row ${speakersStyles.speakerInfo}`}>
                    {speaker.holder && (
                      <div className={`col-12 ${speakersStyles.media}`}>
                        <WPImage
                          holder={speaker.holder}
                          selector={`avatar`}
                          mode={DISPLAY_MODE.inline}
                          className={`${speakersStyles.avatar}`}
                        />
                      </div>
                    )}
                    <div
                      className={`col-12 ${speakersStyles.speakerDetails}`}
                    >
                      {speaker.name && (
                        <h4 className={`${speakersStyles.speakerName}`}>
                          {speaker.name}
                        </h4>
                      )}
                      {speaker.jobDescription && (
                        <h5
                          className={`${speakersStyles.jobDescription}`}
                        >
                          {speaker.jobDescription}
                        </h5>
                      )}
                      {speaker.company && (
                        <h6 className={`${speakersStyles.companyName}`}>
                          {speaker.company}
                        </h6>
                      )}
                    </div>
                  </div>
                  <div
                    className={`row ${speakersStyles.description}`}
                  >
                    <p className={`${speakersStyles.descriptionText}`}>
                      {speaker.description &&
                        speaker.description.map((desc, descIdx) => (
                          <span 
                            key={descIdx}
                            dangerouslySetInnerHTML={{ __html: desc }} 
                          />
                        ))}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
} 